import {WhatsAppOutlined} from '@ant-design/icons'
import Commonview from '../../../pages/common_view';
import CallManage from "../../../pages/call_out/call_manage";
import LanguageManage from "../../../pages/call_out/language_manage";
import TaskManage from "../../../pages/call_out/task_manage";

const CallOutRouter = [
    {
        path: '/CallOut',
        element: <Commonview/>,
        meta: {title: '智能外呼', icon: <WhatsAppOutlined />},
        children: [
            {
                path: '/CallOut/CallManage',
                meta: {title: '任务管理', key: 'ai_call_task_management'},
                element: <CallManage/>,
            },
            {
                path: '/CallOut/language',
                meta: {title: '通话明细', key: 'ai_call_phone_management'},
                element: <LanguageManage/>,
            },
            {
              path: '/CallOut/task',
              meta: {title: '话术管理', key: 'bot_management'},
              element: <TaskManage/>,
          },
        ]
    }
]

export default CallOutRouter
